import { User } from 'Types/user'
import { extractDisplayTtsSegments, extractTtsText } from 'Comps/utils/Markdown'
import { DEFAULT_GREETING } from '@/constant/voices'
import DOMPurify from 'isomorphic-dompurify'
import { isCinemaMessage, CINEMA_ALLOWED_TAGS } from '@/lib/cinema'
export { replaceCharIntroductionPlaceHolders } from '@/utils/homeCardPreview'

export const replaceCharGreetingPlaceHolders = (
  greeting: string,
  charNickname: string,
  userName: string
) => {
  return greeting
    .replaceAll('{{char}}', charNickname)
    .replaceAll('{{user}}', userName)
}

export const getGreetingVoiceText = (
  charGreeting: string,
  charNickname: string,
  user: User | null
) => {
  const greeting = replaceCharGreetingPlaceHolders(
    charGreeting,
    charNickname,
    user?.nickname || ''
  )

  return extractTtsText(greeting).trim().length > 0
    ? extractTtsText(greeting).trim()
    : DEFAULT_GREETING
}

export const getGreetingVoiceSegments = (
  charGreeting: string,
  charNickname: string,
  user: User | null
) => {
  const greeting = replaceCharGreetingPlaceHolders(
    charGreeting,
    charNickname,
    user?.nickname || ''
  )
  const segments = extractDisplayTtsSegments(greeting)
    .filter((segment) => segment.ttsText.length > 0)
    .map((segment) => ({
      text: segment.ttsText,
      texts: segment.ttsTexts,
    }))

  return segments.length > 0
    ? segments
    : [
        {
          text: DEFAULT_GREETING,
          texts: [],
        },
      ]
}

export const patchUserMessage = (content: string) => {
  return DOMPurify.sanitize(content, { ALLOWED_TAGS: [] })
}

export const patchUserEditCharacterMessage = (content: string) => {
  // 检查是否是 cinema 模式消息
  if (isCinemaMessage(content)) {
    // Cinema 模式：允许 cinema XML 标签，移除其他可能的恶意标签
    return DOMPurify.sanitize(content, {
      ALLOWED_TAGS: CINEMA_ALLOWED_TAGS,
    })
  }

  // 原有的 Markdown 消息处理：移除所有标签
  return DOMPurify.sanitize(content, { ALLOWED_TAGS: [] })
}

export function estimateSpeakingSecond(
  text: string,
  wordsPerMinute: number = 120
): number {
  if (!text) return 0
  const words = text.split(/\s+/).length
  return Math.ceil((words * 60) / wordsPerMinute)
}
